<div class="col">
  <div class="changelog-wrapper">
    <div class="changelog-content">

      <mat-card appearance="outlined">
        <mat-card-content>
          <div class="btn-wrapper">
            <a color="primary" mat-stroked-button routerLink="/project">
              <mat-icon style="margin-right: 5px;">home</mat-icon>
              <mat-label>{{ 'MENU.dashboard_label' | translate }}</mat-label>
            </a>
          </div>

          @if ((changes$ | async); as changes) {
            <mat-accordion>
              <div class="grid">
                @for (change of changes; track change; let isFirst = $first) {
                  <mat-expansion-panel [expanded]="!!isFirst">
                    <mat-expansion-panel-header>
                      <mat-panel-title>{{change.version}}</mat-panel-title>
                      <mat-panel-description>{{change.date}}</mat-panel-description>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="change.content | markdown"></div>
                  </mat-expansion-panel>
                }
              </div>
            </mat-accordion>
          } @else {
            <ngx-skeleton-loader class="skeleton" [count]="5"></ngx-skeleton-loader>
          }
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
